import * as Yup from 'yup';

const shapeSchema = Yup.object().shape({
  labelEn: Yup.string().required('English Label is required.'),
  labelAr: Yup.string().required('Arabic Label is required.'),
  code: Yup.string().required('Code is required.'),
  subLabelEn: Yup.string().required('English Sub Label is required.'),
  subLabelAr: Yup.string().required('Arabic Sub Label is required.'),
  previewUrl: Yup.string().required('Preview URL is required.'),
  previewSizeUrl: Yup.string().notRequired(),
  size: Yup.string().required('Size is required.'),
  price: Yup.number().min(0, "Please enter more than 0")
    .required("Price is required.")
    .typeError("Must be Number"),
  discountedPrice: Yup.number().min(0, "Please enter more than 0").typeError("Must be Number"),
  toppingPriceRatio: Yup.number().min(1, "Please enter more than 1").typeError("Must be Number"),
  kg: Yup.number().typeError("Must be Number"),
  // slicedImg: Yup.string().required('Sliced Image is required.'),
  topImg: Yup.string().required('Top Image is required.'),
  frontImg: Yup.string().required('Front Image is required.'),
  position: Yup.number()
    .min(1, "Please enter more than 1")
    .typeError("Must be Number"),
  // slicedColorImg: Yup.string().required('Sliced Color Image is required.'),
  topColorImg: Yup.string().required('Top Color Image is required.'),
  frontColorImg: Yup.string().required('Front Color Image is required.'),
});

export default shapeSchema;